<template>
  <div
    :class="{ 'form-field-error': vee ? vee.classes.failed : false }"
    class="form-input-date"
  >
    <div class="flex">
      <div class="w-14">
        <v-input
          type="text"
          class="form-input-text text-center"
          placeholder="GG"
          style="min-width: 0"
          :disabled="disabled"
          v-model="day"
        />
      </div>
      <div class="w-14 ml-2">
        <v-input
          type="text"
          class="form-input-text text-center"
          placeholder="MM"
          style="min-width: 0"
          :disabled="disabled"
          v-model="month"
        />
      </div>
      <div class="w-20 ml-2">
        <v-input
          type="text"
          class="form-input-text text-center"
          placeholder="AAAA"
          style="min-width: 0"
          :disabled="disabled"
          v-model="year"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },

    value: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    vee: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    segments() {
      return this.value ? this.value.split('-') : ['', '', '']
    },
    day: {
      get() {
        return this.segments[2]
      },
      set(val) {
        const segments = this.segments.slice()
        segments[2] = val

        if (segments.every(value => !value)) {
          this.$emit('input', '')
        } else {
          this.$emit('input', segments.join('-'))
        }
      },
    },
    month: {
      get() {
        return this.segments[1]
      },
      set(val) {
        const segments = this.segments.slice()
        segments[1] = val
        this.$emit('input', segments.join('-'))
      },
    },
    year: {
      get() {
        return this.segments[0]
      },
      set(val) {
        const segments = this.segments.slice()
        segments[0] = val
        this.$emit('input', segments.join('-'))
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
